/* eslint-disable no-useless-escape */
export const formValid = (state) => {
  let phonePattern = /^[0-9]{2,3}(?:-?)[0-9]{3}(?:-?)[0-9]{4}$/;
  let emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let agePattern = /^\d+$/;

  if (state.FullName === "") {
    alert("נדרש למלא שם מלא");
    return false;
  }
  if (state.Age === "") {
    alert("נדרש למלא גיל");
    return false;
  }
  if (state.Email === "") {
    alert("נדרש למלא כתובת מייל");
    return false;
  }
  if (state.PhoneNumber === "") {
    alert("נדרש למלא מספר טלפון");
    return false;
  }

  if (state.PlainText === "") {
    alert("נדרש לבחור קונסולת משחק");
    return false;
  }
  //#endregion

  //#region regex validation
  if (!phonePattern.test(state.PhoneNumber)) {
    alert("נדרש למלא מספר טלפון תקין");
    return false;
  }
  if (!emailPattern.test(state.Email)) {
    alert("נדרש למלא מייל תקין");
    return false;
  }
  if (!agePattern.test(state.Age)) {
    alert("נדרש לכתוב גיל תקין");
    return false;
  }

  //#endregion
  return true;
};
